import "./pd-trash/pd-trash-item.js";
import { PdTrashList } from "./pd-trash/PdTrashList.js";
//#region src/pd-trash/pd-trash-list.ts
var tag = "pd-trash-list";
if (!customElements.get(tag)) customElements.define(tag, PdTrashList);
//#endregion
export { PdTrashList };
